var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"image-viewer"},[_c('div',{staticClass:"viewer-overlay",on:{"click":_vm.handleClose}},[_c('div',{staticClass:"viewer-content"},[_c('div',{staticClass:"viewer-body"},[_c('img',{staticClass:"viewer-image",attrs:{"src":_vm.imageUrl,"mode":"widthFix","alt":"预览图片"}})])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8391d80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageViewer/index.vue
// module id = 52mA
// module chunks = 0